import { render, staticRenderFns } from "./takeALookResult.vue?vue&type=template&id=0aa53495&scoped=true&"
import script from "./takeALookResult.vue?vue&type=script&lang=js&"
export * from "./takeALookResult.vue?vue&type=script&lang=js&"
import style0 from "./takeALookResult.vue?vue&type=style&index=0&id=0aa53495&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa53495",
  null
  
)

export default component.exports